import React, { useState } from 'react';
import {
  IconButton, Menu, MenuItem, ListItemIcon, ListItemText,
  CircularProgress, Typography, Tooltip,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import CodeIcon from '@mui/icons-material/Code';
import DataObjectIcon from '@mui/icons-material/DataObject';
import designStudioService from '../../services/designStudioService';

const ExportMenu = ({ projectId }) => {
  const [anchor, setAnchor] = useState(null);
  const [loading, setLoading] = useState(null); // 'zip'|'html'|'json'|null

  const handleExport = async (type) => {
    setLoading(type);
    setAnchor(null);
    try {
      await designStudioService.exportProject(projectId, type);
    } catch (err) {
      console.error(`Export ${type} failed:`, err);
    } finally {
      setLoading(null);
    }
  };

  const options = [
    { key: 'zip', icon: <FolderZipIcon sx={{ fontSize: 18 }} />, label: 'Download as .zip', sub: 'All source files' },
    { key: 'html', icon: <CodeIcon sx={{ fontSize: 18 }} />, label: 'Export standalone HTML', sub: 'Works offline, no server needed' },
    { key: 'json', icon: <DataObjectIcon sx={{ fontSize: 18 }} />, label: 'Export as JSON', sub: 'Backup / import' },
  ];

  return (
    <>
      <Tooltip title="Export">
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} sx={{ color: '#666' }}>
          {loading ? <CircularProgress size={16} /> : <DownloadIcon sx={{ fontSize: 18 }} />}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
        PaperProps={{ sx: { borderRadius: 2, minWidth: 240 } }}
      >
        {options.map(({ key, icon, label, sub }) => (
          <MenuItem key={key} onClick={() => handleExport(key)} disabled={!!loading} sx={{ py: 1 }}>
            <ListItemIcon sx={{ color: '#555' }}>{icon}</ListItemIcon>
            <ListItemText
              primary={<Typography sx={{ fontSize: 13, fontWeight: 500 }}>{label}</Typography>}
              secondary={<Typography sx={{ fontSize: 11, color: '#999' }}>{sub}</Typography>}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ExportMenu;
